export default {"src":"/_next/static/media/built-for-brokers.62cd9c44.svg","height":107,"width":92};